import { isCPF } from './utils';

export const DocumentLabel = ({ number }) => (isCPF(number) ? 'CPF' : 'CNPJ');
